import _extends from "babel-runtime/helpers/extends";
import _Object$keys from "babel-runtime/core-js/object/keys";
import _classCallCheck from "babel-runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "babel-runtime/helpers/possibleConstructorReturn";
import _inherits from "babel-runtime/helpers/inherits";
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { extractPath } from "@rosetta/redux-utils";
import styled from "@emotion/styled";
import { Spinner, buttonTypes, ModalPrompt, styleVars, MdCancelIcon, MdCheckCircleIcon, MdMicIcon, MdRefreshIcon, MdVolumeUpIcon } from "@rosetta/react-common-ui";
import { LionTranslate } from "@rosetta/react-lion";
import sessionActions from "./sessions/playsound/actions";
import PlaySoundSelectors from "./sessions/playsound/selectors";
import SRECalibrateMeter from "./SRECalibrateMeter";
import { actionCreators, selectors } from "./srereducer";

var SpinnerContainer = styled.div({
  padding: "20px"
});

var VersionDisp = styled.div(function (props) {
  return {
    position: "absolute",
    bottom: 12,
    left: 20,
    fontSize: 10,
    color: extractPath(props, "theme.promptDialogueBackground") || styleVars.white,
    ":hover": {
      color: extractPath(props, "theme.modalContentText") || styleVars.black
    }
  };
});

var ContentContainerDiv = styled.div({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center"
});

var DownloadPercentageDiv = styled.div({
  alignItem: "center",
  justifyContent: "center"
});

var CurrentMicDiv = styled.div({
  alignItem: "center",
  justifyContent: "center",
  textAlign: "center"
});

var InstructionalTextDiv = styled.div({
  textAlign: "center",
  flexShrink: 2
});

var MicAlertDiv = styled.div({
  color: "#EC673F"
});

var MeterBoxDiv = styled.div({
  fontSize: "28px",
  alignItem: "center",
  justifyContent: "center",
  textAlign: "center"
});

var GrayCircleDiv = styled.div({
  height: "100px",
  width: "100px",
  backgroundColor: "#F1F1F1",
  borderRadius: "50%",
  display: "inline-block",
  marginTop: "10px",
  marginBottom: "10px"
});

var MicDiv = styled.div({
  position: "absolute",
  marginTop: "20px",
  marginLeft: "20px"
});

var PlaybackCircleDiv = styled.div(function (props) {
  var style = {
    height: 30,
    width: 30,
    backgroundColor: "#99CC66",
    borderRadius: "50%",
    display: "inline-block",
    verticalAlign: "middle",
    marginLeft: 10,
    marginBottom: 3,
    cursor: "pointer"
  };
  if (props.disabled) {
    style.backgroundColor = styleVars.lightGrey;
    style.pointerEvents = "none";
  }
  return style;
});

var SoundPlaybackDiv = styled.div({
  position: "absolute",
  marginTop: "2px",
  marginLeft: "2px"
});

var SpacerDiv = styled.div({
  marginTop: "10px",
  marginBottom: "10px"
});

var SuccessSpacerDiv = styled.div({
  marginTop: "60px"
});

var NumberPromptDiv = styled.div({
  marginTop: 20,
  marginBottom: 20,
  fontSize: 64,
  letterSpacing: "10px"
});

var MicSelect = styled.select({
  marginTop: 6,
  height: 30,
  fontSize: 13,
  backgroundColor: "#fff",
  border: "1px solid #c3c3c3",
  borderTopColor: "#7c7c7c",
  borderBottomColor: "#ddd",
  fontFamily: "inherit",
  width: 250,
  outline: 0
});

var RefreshDevicesDiv = styled.div(function (props) {
  var style = {
    color: "#4195D3",
    ":hover": {
      color: styleVars.primaryHover
    },
    ":hover:active": {
      color: styleVars.primaryActive
    },
    cursor: "pointer",
    alignSelf: "flex-end",
    paddingLeft: 3,
    paddingRight: 4,
    paddingBottom: 4,
    marginLeft: 4,
    marginTop: -27,
    verticalAlign: "top"
  };
  if (props.disabled) {
    style.color = styleVars.lightGrey;
    style.pointerEvents = "none";
  }
  return style;
});

var REFRESH_SIZE = 18;
var RefreshIconSpan = styled.div({
  display: "inline-block",
  position: "relative",
  top: 4,
  height: REFRESH_SIZE,
  left: 2
});

var RefreshLabelSpan = styled.span({});

var CalibrateWindow = function (_PureComponent) {
  _inherits(CalibrateWindow, _PureComponent);

  function CalibrateWindow() {
    var _temp, _this, _ret;

    _classCallCheck(this, CalibrateWindow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.closeWindow = function () {
      _this.props.closeCalibrateWindow();
      _this.props.unpause && _this.props.unpause();
    }, _this.cancel = function () {
      // If you cancel before trying to calibrate and exitOnCancel is set, we're supposed to exit the app.
      // If you cancel after failing to calibrate, we're supposed to disable speech
      if (_this.props.exitOnCancel && !_this.props.failedCalibration || _this.props.exitOnDisableSpeech) {
        _this.props.exitApp && _this.props.exitApp();
      } else {
        _this.props.disableSpeech();
        _this.closeWindow();
      }
    }, _this.componentDidMount = function () {
      if (_this.props.selfInit) {
        _this.props.initSRE(_this.props.srePath);
      }
    }, _this.getKeyByValue = function (object, value) {
      return _Object$keys(object).find(function (key) {
        return object[key] === value;
      });
    }, _this.onHelpButtonClick = function (event) {
      if (_this.props.getPlaySoundSessionIsPlaying) {
        _this.props.cancelSRESession();
      }
      _this.props.openCalibrateHelp();
    }, _this.onContinueButton = function (event) {
      if (_this.props.isCalibrated) {
        _this.closeWindow();
        return;
      }

      if (_this.props.getPlaySoundSessionIsPlaying) {
        _this.props.cancelSRESession();
      }
      var selMic = _this.getKeyByValue(_this.props.micList, _this.props.selectedMicrophone);
      if (!selMic) {
        // install the default mic
        _this.props.installMic(_this.props.micList[0]);
      }
      _this.props.startCalibrate();
    }, _this.loadingWindow = function () {
      var buttons = [];

      return React.createElement(
        ModalPrompt,
        {
          cancelAction: _this.closeWindow,
          headerTitleKey: "mic_calibration_title",
          dataQa: "CalibrationLoading",
          buttons: buttons,
          modalWidth: "30%",
          hideTipsSection: _this.props.hideSkipCalibrationLink,
          tipsLinkLionKey: "mic_calibration_turn_speech_off",
          tipsLinkAction: _this.disableSpeech,
          hideAllCancelOptions: _this.props.hideAllCancelOptions,
          showNavbar: _this.props.showNavbar
        },
        React.createElement(
          ContentContainerDiv,
          null,
          React.createElement(
            DownloadPercentageDiv,
            null,
            React.createElement(LionTranslate, { lionkey: "progress_downloading_speech_engine" }),
            _this.props.loadingPercent,
            "%"
          ),
          React.createElement(
            SpinnerContainer,
            null,
            React.createElement(Spinner, null)
          )
        )
      );
    }, _this.headerPrompt = function () {
      if (_this.props.isSREListening) return "mic_calibration_checking_microphone";
      if (_this.props.failedCalibration) return "mic_calibration_alert_header";
      if (_this.props.successfulCalibration) return "mic_calibration_microphone_check_successful";
      return "mic_calibration_microphone_check";
    }, _this.topPrompt = function () {
      if (_this.props.isSREListening) return "mic_calibration_please_say";
      return "mic_calibration_start_instruction";
    }, _this.failureReason = function () {
      if (_this.props.failedCalibration) {
        return "mic_calibration_alert_" + _this.props.result.replace(" ", "_");
      }
    }, _this.configureButtons = function () {
      var buttons = [];

      if (!_this.props.hideAllCancelOptions || _this.props.showModalCancelButton) {
        var cancelButton = {
          actionFunc: _this.cancel,
          buttonType: buttonTypes.default,
          disabled: _this.props.isSREListening
        };
        if (_this.props.failedMultiple && _this.props.exitOnDisableSpeech === false) {
          cancelButton.labelKey = "mic_calibration_contin_wo_speech";
        } else {
          cancelButton.labelKey = "misc_cancel";
        }
        if (!_this.props.successfulCalibration) {
          buttons.push(cancelButton);
        }
      }

      var continueButton = {
        actionFunc: _this.onContinueButton,
        buttonType: buttonTypes.primary,
        disabled: _this.props.isSREListening,
        dataQa: "ContinueButton"
      };
      if (_this.props.failedCalibration) {
        continueButton.labelKey = "mic_calibration_retry_calibration";
      } else if (_this.props.successfulCalibration) {
        continueButton.labelKey = "mic_calibration_continue_to_act";
      } else {
        continueButton.labelKey = "mic_calibration_begin";
      }
      buttons.push(continueButton);
      return buttons;
    }, _this.changeMicSelection = function (event) {
      var value = event.currentTarget.value;
      // installMic() tells the SRE engine to store the mic setting
      _this.props.installMic(value);
    }, _this.playbackSound = function () {
      _this.props.startPlaySoundSession(undefined, 0);
    }, _this.disableSpeech = function () {
      _this.props.skipMicCalibration(); // action to be intercepted by app
      _this.closeWindow();
    }, _this.refreshMicList = function () {
      _this.props.refreshMicList();
    }, _this.renderStart = function () {
      var buttons = _this.configureButtons();
      return React.createElement(
        ModalPrompt,
        {
          headerTitleKey: _this.headerPrompt(),
          cancelAction: _this.cancel,
          buttons: buttons,
          dataQa: "CalibrationWindow",
          hideTipsSection: _this.props.hideSkipCalibrationLink,
          tipsLinkLionKey: "mic_calibration_turn_speech_off",
          tipsLinkAction: _this.disableSpeech,
          hideAllCancelOptions: _this.props.hideAllCancelOptions,
          modalHeight: "420px",
          modalWidth: "500px",
          minPadding: false,
          showNavbar: _this.props.showNavbar
        },
        React.createElement(
          ContentContainerDiv,
          null,
          React.createElement(
            InstructionalTextDiv,
            null,
            React.createElement(
              SpacerDiv,
              null,
              React.createElement(LionTranslate, { lionkey: _this.topPrompt() })
            ),
            React.createElement(
              GrayCircleDiv,
              null,
              React.createElement(
                MicDiv,
                null,
                React.createElement(MdMicIcon, { color: "#4195D3", size: "60" })
              )
            ),
            React.createElement(
              SpacerDiv,
              null,
              React.createElement(LionTranslate, { lionkey: "mic_calibration_start_next_prompt" }),
              " ",
              React.createElement("br", null)
            )
          ),
          React.createElement(
            CurrentMicDiv,
            null,
            React.createElement(
              MicSelect,
              { value: _this.props.selectedMicrophone || "", "data-qa": "MicList", onChange: _this.changeMicSelection },
              _this.props.micList.map(function (opt) {
                return React.createElement(
                  "option",
                  { value: opt, key: opt },
                  opt
                );
              })
            )
          ),
          React.createElement(
            RefreshDevicesDiv,
            { onClick: _this.refreshMicList },
            React.createElement(
              RefreshLabelSpan,
              null,
              React.createElement(LionTranslate, { lionkey: "device_settings_refresh_button" })
            ),
            React.createElement(
              RefreshIconSpan,
              null,
              React.createElement(MdRefreshIcon, { size: REFRESH_SIZE })
            )
          )
        ),
        React.createElement(
          VersionDisp,
          null,
          _this.props.sreVersion
        )
      );
    }, _this.renderListening = function () {
      return React.createElement(
        ModalPrompt,
        {
          headerTitleKey: _this.headerPrompt(),
          dataQa: "CalibrationWindow",
          modalHeight: "420px",
          modalWidth: "500px",
          minPadding: false,
          showNavbar: _this.props.showNavbar
        },
        React.createElement(
          ContentContainerDiv,
          null,
          React.createElement(
            InstructionalTextDiv,
            null,
            React.createElement(
              SpacerDiv,
              null,
              React.createElement(LionTranslate, { lionkey: _this.topPrompt() })
            ),
            React.createElement(
              MeterBoxDiv,
              null,
              React.createElement(
                NumberPromptDiv,
                null,
                React.createElement(LionTranslate, { lionkey: "mic_calibration_text_act_label" })
              ),
              _this.props.isSREListeningToPrompt && React.createElement(SRECalibrateMeter, { showButton: false })
            )
          ),
          React.createElement("br", null)
        )
      );
    }, _this.renderSuccessful = function () {
      var buttons = _this.configureButtons();

      return React.createElement(
        ModalPrompt,
        {
          headerTitleKey: _this.headerPrompt(),
          cancelAction: _this.cancel,
          buttons: buttons,
          dataQa: "CalibrationWindow",
          modalHeight: "420px",
          modalWidth: "500px",
          minPadding: false,
          hideAllCancelOptions: _this.props.hideAllCancelOptions,
          showNavbar: _this.props.showNavbar
        },
        React.createElement(
          ContentContainerDiv,
          null,
          React.createElement(
            InstructionalTextDiv,
            null,
            React.createElement(
              SuccessSpacerDiv,
              null,
              React.createElement(
                SpacerDiv,
                null,
                React.createElement(MdCheckCircleIcon, { color: "#99CC66", size: "120" })
              ),
              React.createElement(
                SpacerDiv,
                null,
                React.createElement(LionTranslate, { lionkey: "mic_calibration_all_set" })
              )
            )
          )
        )
      );
    }, _this.renderFailure = function () {
      var buttons = _this.configureButtons();

      return React.createElement(
        ModalPrompt,
        {
          headerTitleKey: _this.headerPrompt(),
          cancelAction: _this.cancel,
          buttons: buttons,
          dataQa: "CalibrationWindow",
          hideTipsSection: false,
          tipsLinkAction: _this.onHelpButtonClick,
          tipsLinkLionKey: "mic_calibration_tips",
          modalHeight: "420px",
          modalWidth: "500px",
          minPadding: false,
          hideAllCancelOptions: _this.props.hideAllCancelOptions,
          showNavbar: _this.props.showNavbar
        },
        React.createElement(
          ContentContainerDiv,
          null,
          React.createElement(
            InstructionalTextDiv,
            null,
            React.createElement(
              SpacerDiv,
              null,
              React.createElement(
                MicAlertDiv,
                null,
                _this.props.isSREListening !== true && _this.props.result !== "" && _this.props.result !== "ok" && React.createElement(
                  "div",
                  null,
                  React.createElement(
                    "span",
                    null,
                    React.createElement(LionTranslate, { lionkey: _this.failureReason() })
                  ),
                  React.createElement(
                    "span",
                    null,
                    React.createElement(
                      PlaybackCircleDiv,
                      {
                        onClick: _this.playbackSound,
                        disabled: _this.props.getPlaySoundSessionIsPlaying
                      },
                      React.createElement(
                        SoundPlaybackDiv,
                        null,
                        React.createElement(MdVolumeUpIcon, { color: "#ffffff", size: "26" })
                      )
                    )
                  )
                )
              )
            ),
            React.createElement(
              SpacerDiv,
              null,
              React.createElement(MdCancelIcon, { color: "#FA624D", size: "120" })
            )
          ),
          React.createElement(
            CurrentMicDiv,
            null,
            React.createElement(LionTranslate, { lionkey: "mic_calibration_current_mic" }),
            " ",
            React.createElement("br", null),
            React.createElement(
              MicSelect,
              { value: _this.props.selectedMicrophone || "", "data-qa": "MicList", onChange: _this.changeMicSelection },
              _this.props.micList.map(function (opt) {
                return React.createElement(
                  "option",
                  { value: opt, key: opt },
                  opt
                );
              })
            )
          ),
          React.createElement(
            RefreshDevicesDiv,
            { onClick: _this.refreshMicList },
            React.createElement(
              RefreshLabelSpan,
              null,
              React.createElement(LionTranslate, { lionkey: "device_settings_refresh_button" })
            ),
            React.createElement(
              RefreshIconSpan,
              null,
              React.createElement(MdRefreshIcon, null)
            )
          )
        )
      );
    }, _this.render = function () {
      if (_this.props.sreLoading) {
        return _this.loadingWindow();
      }

      if (_this.props.isSREListening) return _this.renderListening();
      if (_this.props.failedCalibration) return _this.renderFailure();
      if (_this.props.successfulCalibration) return _this.renderSuccessful();
      return _this.renderStart();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return CalibrateWindow;
}(PureComponent);

CalibrateWindow.propTypes = {
  unpause: PropTypes.func,
  exitApp: PropTypes.func,
  hideSkipCalibrationLink: PropTypes.bool,
  hideAllCancelOptions: PropTypes.bool,
  showModalCancelButton: PropTypes.bool,
  showNavbar: PropTypes.bool,
  selfInit: PropTypes.bool // Should the calibrate window automatically call initSRE (default true)
};
CalibrateWindow.defaultProps = {
  hideSkipCalibrationLink: false,
  showNavbar: true,
  showModalCancelButton: false,
  selfInit: true
};


var mapStateToProps = function mapStateToProps(state) {
  return {
    isSREListening: selectors.isSREListening(state),
    isSREListeningToPrompt: true,
    isCalibrated: selectors.isSRECalibrated(state),
    result: selectors.sreCalibrateResult(state),
    selectedMicrophone: selectors.sreSelectedMicrophone(state),
    sreLoading: selectors.isSRELoading(state),
    loadingPercent: selectors.sreLoadingPercent(state),
    failedCalibration: selectors.failedCalibration(state),
    successfulCalibration: selectors.successfulCalibration(state),
    exitOnCancel: selectors.isSREExitOnCancel(state),
    exitOnDisableSpeech: selectors.isSREExitOnDisableSpeech(state),
    srePath: selectors.srePath(state),
    failedMultiple: selectors.sreCalibrateFailureCount(state) >= 2,
    getPlaySoundSessionIsPlaying: PlaySoundSelectors.getPlaySoundSessionIsPlaying(state),
    micList: selectors.sreMicList(state),
    sreVersion: selectors.sreVersion(state)
  };
};

var CalibrateWindowContainer = connect(mapStateToProps, _extends({}, actionCreators, sessionActions))(CalibrateWindow);

export { CalibrateWindow };
export default CalibrateWindowContainer;